import {ProjectSettings} from "config";
import { IUpdateSB } from '../model/altenar-service.types';


declare const window: any;

interface IUpdate {
    url?: string;
    stickyTop?: number;
    betslipButton?: string;
    betSlipOffsetTop?: number;
    betSlipOffsetRight?: number;
    betSlipOffsetBottom?: number;
}

const services = ProjectSettings.services();

export class AltenarService {
    public altSportBook: any;
    private altenar: any;
    constructor(token: string, culture?: string) {
        try {
            window.altenarWSDK.init({
                integration: services.ALTENAR?.INTEGRATION,
                culture,
                token,
            });
            this.altenar = window.altenarWSDK;
        } catch (e) {
            console.warn(e);
        }
    }

    public clean() {
        this.altSportBook.remove();
    }

    public authAltenar(token: string) {
        this.altenar.set({ token });
    }

    public updateSB(obj?: IUpdateSB) {
        this.altenar.set(obj);
    }
    public addSportbook(setting?: any) {
        try {
            window.ASB = this.altenar.addSportsBook({
                props: {
                    ...setting,
                    //routerType: "memory",
                },
                container: document.getElementById('altenar'),
            });
            this.altSportBook = window.ASB;

            return this.altSportBook;
        } catch (e) {
            console.warn(e);
        }
    }
}
